export abstract class UtilityHelper {
    public static arraySortByProperty = (arrayToSort: Array<any>, property: string, reverseSort: boolean = false): void => {
        !reverseSort ? arrayToSort.sort((a, b) => (a[property] > b[property]) ? 1 : ((b[property] > a[property]) ? -1 : 0))
            : arrayToSort.sort((b, a) => (a[property] > b[property]) ? 1 : ((b[property] > a[property]) ? -1 : 0));
    }
}